import { is } from "bpmn-js/lib/util/ModelUtil";
import { isExpanded as isBpmnExpanded } from "bpmn-js/lib/util/DiUtil";

export type FlussCanvasTranslator = (key: string, options?: { defaultValue?: string }) => string;
let translate: FlussCanvasTranslator = (key, options) => options?.defaultValue ?? key;

export const setFlussSubProcessToggleTranslate = (next: FlussCanvasTranslator) => {
    translate = next;
};

function FlussSubProcessToggleProvider(this: any, contextPad: any, modeling: any) {
    contextPad.registerProvider(this);

    this.getContextPadEntries = (element: any) => (entries: Record<string, any>) => {
        if (!is(element, "bpmn:SubProcess") || is(element, "bpmn:CallActivity")) return entries;
        const isExpanded = isBpmnExpanded(element);
        return {
            ...entries,
            "fluss-toggle-collapse": {
                group: "edit",
                className: isExpanded ? "bpmn-icon-subprocess-collapsed" : "bpmn-icon-subprocess-expanded",
                title: translate(
                    isExpanded ? "fluss.canvas.collapse_subprocess" : "fluss.canvas.expand_subprocess",
                    { defaultValue: isExpanded ? "Collapse sub-process" : "Expand sub-process" },
                ),
                action: {
                    click: (event: Event) => {
                        event.preventDefault();
                        modeling.toggleCollapse(element);
                    },
                },
            },
        };
    };
}

(FlussSubProcessToggleProvider as any).$inject = ["contextPad", "modeling"];

export const flussSubProcessToggleModule = {
    __init__: ["flussSubProcessToggleProvider"],
    flussSubProcessToggleProvider: ["type", FlussSubProcessToggleProvider],
};
